import styled from 'styled-components';
import { colors } from '@alixpartners/ui-components';

export const ProgressBarLabel = styled.span`
	display: inline-block;
	color: ${colors.grey5};
	font-size: 13px;
	line-height: 19px;
	letter-spacing: 0.3px;
	margin-bottom: 24px;
	text-align: center;
`;

export const ProgressBarBackground = styled.div`
	background: ${colors.grey2};
	height: 4px;
	margin-bottom: 13px;
	width: 100%;
`;

export const ProgressBarMarker = styled.div`
	background: ${colors.chartBrightTeal};
	transition: width 2s;
	height: 4px;
`;

export const ProgressWrapper = styled.div`
	width: 432px;
	min-width: 432px;
	align-self: center;
	display: flex;
	flex-direction: column;
	padding-top: 32px;
	padding-bottom: ${props => (props.timeRequired ? '0px' : '64px')};
`;

export const EtlProgressLabel = styled.div`
	display: inline-block;
	color: ${colors.grey5};
	font-size: 17px;
	font-weight: 500;
	line-height: 19px;
	letter-spacing: 0.3px;
	margin-bottom: 24px;
	text-align: center;
`;

export const TimeRequired = styled.div`
	font-size: 13px;
	line-height: 19px;
	letter-spacing: 0.3px;
	font-weight: 400;
	margin-bottom: 24px;
	margin-top: 10px;
	color: ${colors.grey5};
`;
